export default "__VITE_ASSET__vFV43L5F__"